import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account, ACHBatch, ACHTemplate } from "model";

/**
* @class ACHFromAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.achFromAccounts[0];
* const contactInfo = new ACHFromAccount(record);
* @property {NUMBER} _id - The id of the ACHFromAccount.
*/
export default class ACHFromAccount extends BCMSRecord {
    _id
    _account
    _oneTimeACHPayment
    _achTemplte
    _amount

    constructor (record){     
      super(record) 
    }
  }

  ACHFromAccount.define({
    "recordType": "achFromAccounts",
    "recordIDProp": "id",
    "className" : "ACHFromAccount",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHFromAccount
       */
      BCMSRecordProperty.mapToNumber("id","_id"),

      /** 
       * @name account
       * @instance
       * @property get {STRING} - gets the account value
       * @property set {STRING} - sets the account value
       * @memberof ACHFromAccount
       */
      BCMSRecordProperty.mapToClass("account", "_account", () => Account),

      /** 
       * @name oneTimeACHPayment
       * @instance
       * @property get {STRING} - gets the oneTimeACHPayment value
       * @property set {STRING} - sets the oneTimeACHPayment value
       * @memberof ACHFromAccount
       */
      BCMSRecordProperty.mapToClass("oneTimeACHPayment", "_oneTimeACHPayment", () => ACHBatch),

      /** 
       * @name achTemplate
       * @instance
       * @property get {STRING} - gets the achTemplate value
       * @property set {STRING} - sets the achTemplate value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToClass("achTemplate", "_achTemplate", () => ACHTemplate),

       /** 
       * @name amount
       * @instance
       * @property get {STRING} - gets the amount value
       * @property set {STRING} - sets the amount value
       * @memberof ACHFromAccount
       */
      BCMSRecordProperty.mapToCurrency("amount", "_amount"),

    ]  
})




